import { createFileRoute, redirect } from '@tanstack/react-router';

import { claimQueries } from '@repo/api/claim/claims';
import { FNOLForm, isValidPage, Page } from '@repo/features/fnol';

import { Route as ClaimRoute } from '../_claim';

export const Route = createFileRoute(
	'/_claims/claim/$claimId/(fnol)/edit/$page',
)({
	beforeLoad: ({ params, context }) => {
		const { claimId, page } = params;

		if (!context.user?.permissions.includes('claim.edit')) {
			throw redirect({
				to: '/',
			});
		}

		if (!isValidPage(page)) {
			throw redirect({
				to: Route.to,
				params: {
					claimId,
					page: 'insured',
				},
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.ensureQueryData(claimQueries.id(params.claimId));
	},
	component: function EditClaimPage() {
		const { page: pageParam, claimId } = Route.useParams();

		const page: Page = isValidPage(pageParam) ? pageParam : 'insured';

		const navigate = Route.useNavigate();

		const navigateToPage = async (targetPage?: Page, scrollKey?: string) => {
			if (targetPage && page !== targetPage) {
				await navigate({
					to: Route.to,
					params: (params) => ({
						...params,
						page: targetPage,
					}),
				});
			}

			if (scrollKey) {
				document.getElementById(scrollKey)?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
		};
		return (
			<FNOLForm
				key={claimId}
				claimId={claimId}
				page={page}
				navigateToPage={navigateToPage}
				exit={() => {
					return navigate({
						to: ClaimRoute.to,
					});
				}}
				title="Edit Claim"
			/>
		);
	},
	head: (ctx) => ctx.match.context.setTitle('Claim', 'Edit'),
});
